export const submitToCollect = ({
  key,
  rating,
  message,
  identity,
  reference,
}) => {
  const myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-Type', 'application/json');

  //
  const raw = JSON.stringify({
    key,
    response: {
      rating,
      content: message,
      identity,
      reference,
    },
  });

  const requestOptions: any = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  //
  let endPoint;

  try {
    endPoint =
      window['collectResponseEndpoint'] ||
      window.top!['collectResponseEndpoint'] ||
      'https://collect.chameleoncreator.com/api/v1/responses/create';
  } catch (err) {
    console.log('ERROR GETTING REFERENCE TO COLLECT ENDPOINT :', err);
    //
    endPoint =
      window['collectResponseEndpoint'] ||
      'https://collect.chameleoncreator.com/api/v1/responses/create';
  }

  if (!(window as any).hosted) {
    fetch(endPoint, requestOptions)
      .then(response => {
        return response.text();
      })
      .then(result => console.log(result))
      .catch(error => console.log('error', error));
  }
};
